<wbo-select-option [value]="AccountDetailsData.LIMIT_DURATION_DAILY" label="wbo.account.edit.limitduration.option.daily">
</wbo-select-option>
<wbo-select-option [value]="AccountDetailsData.LIMIT_DURATION_WEEKLY" label="wbo.account.edit.limitduration.option.weekly">
</wbo-select-option>
<wbo-select-option [value]="AccountDetailsData.LIMIT_DURATION_MONTHLY" label="wbo.account.edit.limitduration.option.monthly">
</wbo-select-option>
<wbo-select-option [value]="AccountDetailsData.LIMIT_DURATION_YEARLY" label="wbo.account.edit.limitduration.option.yearly">
</wbo-select-option>
